module.exports = __webpack_public_path__ + "static/media/icono_circense.ff39da79.svg";